<template>
	<div>
		<div class="orderbox">
			<figure style="width:100%; text-align:center;padding-top:50px;" v-if="list.length==0">
				   <img src="@/assets/kong.png" alt="" srcset="" />
				   <figcaption>暂无数据</figcaption>
			</figure>
			<div v-for="(i,index) in list" :key="index" class="liebiao1" @click="datails(i.o_id)">
				<div class="orderTitle">
					<h3>{{i.demand.name}}</h3>
					<span style="color:#FF0000;" v-if="i.status==0">待需方付款</span>
					<span style="color:#4DC800;" v-if="i.status==1 || i.status==2 || i.status==3 || i.status==4">进行中</span>
					<span style="color:#FF5900;" v-if="i.status==5 && i.serve_score==0">待评价</span>
					<span style="color:#FF0000;" v-if="i.status==-1">已取消</span>
					<span style="color:#1E3A8A;" v-if="i.status==5 && i.serve_score>0">已完成</span>
					<span style="color:#FF0000;" v-if="i.status==-2">已退款</span>
<!-- 					<span style="color:#FF5900;" v-if="i.type==6">已收藏</span> -->
				</div>
				<div class="orderbh1">订单编号：{{i.order_sn}}</div>
				<div class="orderbh2"><span>需求方：</span>{{i.demandUser.nickname}}</div>
				<div class="orderbh3"><span>订单金额：</span>￥{{i.quote_price}}</div>
				<div v-if="i.status==1 || i.status==2 || i.status==3 || i.status==4" class="orderbh4">
					<el-badge class="item" :is-dot="i.unread_message_count>0">
					  <div class="orderbh4_1" @click.stop="liuyan(i.o_id,i.status)">留言</div>
					</el-badge>
					<div class="orderbh4_2" @click.stop="chakan(i.o_id)" v-if="i.has_review=='true'">查看评审</div>
				</div>
				<div v-if="i.status==5 && i.has_review=='true' && i.message_count>0" class="orderbh4">
					<div class="orderbh4_2" @click.stop="chakan(i.o_id)">查看评审结果</div>
					<div class="orderbh4_2"@click.stop="liuyan(i.o_id,i.status)">查看留言</div>
				</div>
				<div v-if="i.status==5 && i.has_review=='true' && i.message_count==0" class="orderbh4">
					<div class="orderbh4_2"  @click.stop="chakan(i.o_id)">查看评审结果</div>
				</div>
				<div v-if="i.status==5 && i.has_review !='true' && i.message_count>0" class="orderbh4">
					<div class="orderbh4_2" @click.stop="liuyan(i.o_id,i.status)">查看留言</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		  
	    }
	  },
	  props:{
		  list:{}
	  },
	  methods: {
		 chakan(e){
		  	const targetPath = '/serviceHome/serviceOrder/Reviewdatails?oid='+e
		  	if (this.$route.path !== targetPath) {
		  		this.$router.push(targetPath)
		  	}
		},
		datails(e){
			const targetPath = '/serviceHome/serviceOrder/orderDatails?o_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		liuyan(id,status){
			const targetPath = '/serviceHome/serviceOrder/servicmessage?oid='+id+"&status="+status
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		}
	  },
	}
</script>

<style scoped>
	.orderbox{
		width:1200px;
		margin:0 auto;
	}
	.orderbox>div:nth-child(3n){
		margin-right:0px;
	}
	.liebiao1{
		width:384px;
		height:176px;
		float: left;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		margin-bottom:24px;
		margin-right:24px;
		padding:12px;
		box-sizing: border-box;
		cursor:pointer;
		transition: all 0.3s;
	}
	.liebiao1:hover{
		transform: scale(1.03);
	}
	.orderTitle{
		width:100%;
		display:flex;	
	    justify-content:space-between;
		align-items: center;
	}
	.orderTitle h3{
		width:260px;
		overflow: hidden;
		text-overflow: ellipsis; 
		white-space: nowrap; 
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.orderTitle span{
		font-weight: bold;
		font-size: 14px;
	}
	.orderbh1{
		font-weight: 500;
		font-size: 12px;
		color: #999999;
		margin-top:10px;
	}
	.orderbh2{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
		margin-top:10px;
	}
	.orderbh2 span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.orderbh3{
		font-weight: 500;
		font-size: 14px;
		color: #FF5900;
		margin-top:10px;
	}
	.orderbh3 span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.orderbh4{
		width:100%;
		margin-top:12px;
		display:flex;
		justify-content:end;
	}
	.orderbh4_1{
		text-align: center;
		min-width:76px;
		padding:6px;
		box-sizing: border-box;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		margin-left:15px;
	}
	.orderbh4_2{
		text-align: center;
		min-width:76px;
		padding:6px;
		box-sizing: border-box;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
		margin-left:15px;
	}
</style>